import RenderMark from "../../../shared/components/RenderMark";
import PlusMinus from "../../../shared/components/icons/PlusMinus";
import useScrollIntoView from "../../../shared/hooks/useScrollIntoView";
import t from "../../../shared/translations";
import { Accordion, AccordionHead } from "../stylings/accordion";
import type { IAccordion } from "./Theory";
import type { JSX } from "react";

interface IProps {
    content: string;
    open: boolean;
    toggle: (acc: IAccordion) => void;
}

function SL({ content, open, toggle }: IProps): JSX.Element {
    const ref = useScrollIntoView<HTMLDivElement>(open);
    return (
        <Accordion ref={ref}>
            <AccordionHead onClick={() => toggle("SL")}>
                <h2 id="sl">{t("player.team-scan-theory.heading-sl")}</h2>
                <PlusMinus open={open} />
            </AccordionHead>
            {open && <RenderMark content={content} />}
        </Accordion>
    );
}

export default SL;
